import { useState } from 'react'
import { faqs } from '@/lib/content'
import {ChevronDown} from 'lucide-react'

export default function FaqList() {
  const [open, setOpen] = useState<number | null>(0)

  return (
    <div className="divide-y divide-white/10 border-y border-white/10">
      {faqs.map((item, index) => {
        const isOpen = open === index
        return (
          <div key={item.q}>
            <button
              type="button"
              className="flex w-full items-start justify-between gap-6 py-5 text-left"
              aria-expanded={isOpen}
              onClick={() => setOpen(isOpen ? null : index)}
            >
              <span className="text-[15px] font-medium text-white sm:text-base">{item.q}</span>
              <ChevronDown className={`mt-1 h-4 w-4 shrink-0 text-orange-300 transition ${isOpen ? 'rotate-180' : ''}`} />
            </button>
            {isOpen ? (
              <div className="pb-5 pr-8">
                {item.a.map((paragraph, pIndex) => (
                  <p
                    key={pIndex}
                    className={`text-sm leading-relaxed text-white/60 ${pIndex > 0 ? 'mt-3' : ''}`}
                  >
                    {paragraph}
                  </p>
                ))}
                {item.tags?.length ? (
                  <div className="mt-4 flex flex-wrap gap-2">
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs font-medium text-white/70"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>
        )
      })}
    </div>
  )
}
